import React from "react";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {checkPermission} from "./redux_slices/contextSlice";

export const ErrorFallback = props => {
    const {error, resetErrorBoundary} = props;
    const {t} = useTranslation();
    const isAdmin = useSelector(state => checkPermission(state, `settings.viewMenuLink`));

    return (
        <div className="h-100 w-100 d-flex justify-content-center align-items-center bg-light">
            <div className={`d-flex font-size-h5 font-weight-bold`}>
                <div className="d-flex h-100 align-items-center">
                    <WarningRoundedIcon color="secondary" style={{fontSize: "100px"}} />
                </div>
                <div className="ml-4 d-flex justify-content-center flex-column">
                    <h3>{t("ERRORBOUNDARY.TITLE")}</h3>
                    <h4 className="text-muted">{t("ERRORBOUNDARY.MESSAGE")}</h4>
                    {error?.message && isAdmin ? (
                        <pre style={{maxHeight: 200, maxWidth: 600, overflow: "auto"}}>{error.message}</pre>
                    ) : null}
                    <button className={`btn btn-info`} onClick={resetErrorBoundary}>
                        {t("ERRORBOUNDARY.RELOAD")}
                    </button>
                </div>
            </div>
        </div>
    );
};
